import { Link } from 'react-router-dom';
import { CreditCard, Building2, Bell, Users, ShieldCheck, ArrowRight, CircleDollarSign } from 'lucide-react';
import { Card } from '@techsofit/ui';

const SCREENS = [
  { icon: CreditCard, title: 'Subscription plans', body: 'Manage the public pricing tiers and the annual discount.', to: '/plans' },
  { icon: Building2, title: 'Gyms & billing', body: 'Record payments, upgrade plans, and track revenue across every tenant.', to: '/billing' },
  { icon: CircleDollarSign, title: 'Revenue', body: 'Every gym subscription payment — which gym, when, and how much.', to: '/revenue' },
  { icon: Bell, title: 'Notifications', body: 'Turn email, WhatsApp and SMS channels on or off platform-wide.', to: '/settings' },
  { icon: Users, title: 'Platform users', body: 'Provision gym owners and platform admins.', to: null },
  { icon: ShieldCheck, title: 'Support view', body: 'Open a gym as staff, with a banner so you never forget you are in support.', to: '/billing' },
];

/** Console home — entry points into the platform modules. */
export function HomePage() {
  return (
    <>
      <Card tone="dark" className="mt-4 overflow-hidden p-8 md:p-12">
        <p className="text-eyebrow uppercase text-accent">admin.techsofit</p>
        <h1 className="mt-3 max-w-2xl font-display text-display-lg text-on-dark">
          One console for every gym on the platform.
        </h1>
        <p className="mt-3 max-w-lg text-on-dark-muted">
          Manage pricing, onboard tenants, and keep every gym’s subscription current.
        </p>
      </Card>

      <div className="mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {SCREENS.map((s) => {
          const inner = (
            <Card className="flex h-full flex-col p-5 transition-shadow hover:shadow-card-hover">
              <span className="inline-flex size-10 items-center justify-center rounded-control bg-surface text-ink-soft">
                <s.icon className="size-5" aria-hidden />
              </span>
              <h2 className="mt-4 flex items-center gap-1.5 font-display text-lg font-semibold text-ink">
                {s.title}
                {s.to && <ArrowRight className="size-4 text-muted" aria-hidden />}
              </h2>
              <p className="mt-1 text-sm text-muted">{s.body}</p>
              {!s.to && <p className="mt-2 text-xs font-medium text-muted">Coming soon</p>}
            </Card>
          );
          return s.to ? (
            <Link key={s.title} to={s.to} className="block">{inner}</Link>
          ) : (
            <div key={s.title} className="opacity-70">{inner}</div>
          );
        })}
      </div>
    </>
  );
}
